<!--
* UI Name: Delete History Workflow Dialog
* Modify Date: 2021.08.25
* Description: It's used for function delete in UIs
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    :options="options"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="popup-delete"
  >
    <system-progress
      :sysloading="isLoading"
      :sysloadingTitle="sysloadingTitle"
    ></system-progress>
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title class="headline white--text warning" primary-title>
        {{$t('lbl.delHistoryWorkflowDialog.title')}}
        <v-spacer />
        <v-icon small class="mr-2" @click="removeDialog" color="white">fas fa-times</v-icon>
      </v-card-title>
      <!-- [E]  Popup title-->
    </template>
    <v-card class="analyzed-dialog matched-map-list-dialog">
      <v-card-text class="pa-0 popup-title">
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0">
            <span class="title-file-name--text">{{options.item.comNm}}</span>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0">
            <span>{{ $t('msg.delHistoryWorkflowDialog.messageWarningTop') }}</span>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [S]  Popup body-->
      <v-card-text class="pa-0">
        <v-row>
          <v-col cols="12">
            <v-row class="version-history-table ma-0">
              <v-col cols="12" class="pa-0">
                <v-data-table
                  :items="versionList"
                  :hide-default-footer="true"
                  :fixed-header="true"
                  class="analyzed-layout-table"
                  disable-pagination
                  disable-sort
                  :height="customHeight"
                >
                  <template v-slot:body="{ items }">
                    <thead>
                      <tr>
                        <th
                          class="text-center text-version"
                          style="width:51px"
                        >{{$t('tbl.delHistoryWorkflowDialog.ver')}}</th>
                        <th
                          v-if="compNm"
                          class="text-center text-version"
                          style="width:100px"
                        >{{compNm}}</th>
                        <th
                          class="text-center text-version"
                          style="width:133px"
                        >{{$t('tbl.delHistoryWorkflowDialog.processName')}}</th>
                        <th
                          class="text-center text-version"
                          style="width:133px"
                        >{{$t('tbl.delHistoryWorkflowDialog.date')}}</th>
                        <th
                          class="text-center text-version"
                          style="width:133px"
                        >{{$t('tbl.delHistoryWorkflowDialog.user')}}</th>
                        <th
                          class="text-center text-version"
                          style="width:80px"
                        >{{$t('tbl.delHistoryWorkflowDialog.status')}}</th>
                        <th
                          class="text-center text-version"
                        >{{$t('tbl.delHistoryWorkflowDialog.changeHistory')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in items" :key="compNm ? (item.compNm + item.id) : item.id">
                        <td class="text-center text-bold">{{item.verNo ? item.verNo :'Initial'}}</td>
                        <td v-if="compNm" class="text-center text-bold">{{item.compNm}}</td>
                        <td class="text-left text-bold">{{ item.procNm }}</td>
                        <td class="text-left">{{ item.creDt }}</td>
                        <td class="text-left text-bold">{{ item.creUsrId }}</td>
                        <td class="text-left">{{ item.applySts }}</td>
                        <td class="text-left">{{ item.comment }}</td>
                      </tr>
                    </tbody>
                  </template>
                  <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">{{$t('btn.common.reset')}}</v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup body-->
      <!-- [S]  Popup buttons-->
      <v-card-text class="footer-display-popup">
        <v-row class="ma-0">
          <v-col cols="6" class="pa-0">
            <span v-html="$t('msg.delHistoryWorkflowDialog.messageWarningBottom')"></span>
          </v-col>
          <v-col cols="6" class="pa-0">
            <v-btn class="btn btn-popup-search primary float-left" tile dark @click="checkBeforeDetele">
              {{$t('btn.common.confirm')}}
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0">
            <v-btn class="btn btn-delete float-right" tile dark @click="removeDialog">
              {{$t('btn.common.close')}}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup buttons-->
    </v-card>
    <dialogWindow
      ref="DeleteComponent"
      size="max"
      :detail="
        $t('msg.common.infoConfirm.detail', ['delete this component'])
      "
      color="confirmation"
      :showCancel="true"
      @select-ok="deleteProcess()"
    ></dialogWindow>
    <dialogWindow
      ref="AlertLockWF"
      size="max"
      :detail="alertMessage"
      color="warning"
    >
    </dialogWindow>
    <dialogWindow
      ref="AlertProcessSetup"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="removeDialog"
    ></dialogWindow>
  </dialog-drag>
</template>

<script>
import DialogDrag from "@/vue-dlb/components/vue-dialog-drag.vue";
import dialogWindow from "@/vue-dlb/components/NewDialog.vue";
import EventBus from "@/vue-caas/views/process/component/event-bus.js";
import { mapState } from "vuex";
import SystemProgress from "@/vue-dlb/components/SystemProgress.vue";

export default {
  components: {
    DialogDrag,
    dialogWindow,
    SystemProgress,
  },
  props: {
    id: String,
    title: String,
    compNm: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
  },
  data: () => ({
    versionList: [],
    currentVerItems: {},
    seletedDelete: {},
    oldVersion: "",
    customHeight: 61,
    isClick: true,
    processViewArr: [],
    alertMessage: "",
    checkDialogColor: 'success',
    checkDialogInfo: '',
    isLoading: false,
  }),
  watch: {
    "options.item.versionList"() {
      this.versionList = this.options.item.versionList;
      let len = this.versionList.length;
      this.customHeight = (len > 7 ? 7 : len) * 35 + 26;
    },
  },
  created() {
    this.versionList = this.options.item.versionList;
    console.log(this.options.item)
    let len = this.versionList.length;
    this.customHeight = (len > 7 ? 7 : len) * 35 + 26;
  },
  computed: {
    ...mapState("common", {
      sysloadingTitle: "sysloadingTitle",
    }),
  },
  methods: {
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    async checkBeforeDetele() {
      this.isLoading = true;
      let modifyingList = [];
      for (let i = 0; i < this.versionList.length; i++) {
        await this.$store.dispatch("getLockProcessNew", {procId: this.versionList[i].procId, lockWF: true}).then((res) => {
          if(res.editUser){
            modifyingList.push(this.versionList[i].procNm)
          }
        }).catch((err) => {
          this.isLoading = false;
        });
      }
      if (modifyingList.length > 0) {
        this.$refs.AlertLockWF.dialog = true;
        this.alertMessage = `You can't delete this component because ${modifyingList.toString()} is modifying.`;
      } else {
        this.$refs.DeleteComponent.dialog = true;
      }
      this.isLoading = false;
    },
    async deleteProcess() {
      // 2025/13/1 SPKA-803 Delete only the component, instead of deleting all workflows
      // this.isLoading = true;
      // for (let i = 0; i < this.versionList.length; i++) {
      //   const params = {
      //     id: this.versionList[i].id,
      //     actCd: 'D',
      //     procId: this.versionList[i].procId,
      //     compId: this.versionList[i].compId,
      //     version: this.versionList[i].verNo,
      //     hash: this.$cookies.get("hash"),
      //   };
      //   await this.$store.dispatch('deleteProcessNew', params).then(() => {
      //   }).catch((err) => {
      //     // alert(`Exception occured. Reason: ${err}`);
      //     this.isLoading = false;
      //   });
      //   if (!this.isLoading) break;
      // }
      // if (this.isLoading) {
        await EventBus.$emit("delete-item", this.options.item.item, this.options.item.nodeId);
        this.closeDialog(this.id);
      // }
      // if (this.isLoading) {
      //   this.$refs.AlertProcessSetup.dialog = true;
      //   this.checkDialogColor = 'success';
      //   this.checkDialogInfo = 'All related workflows have been deleted successfully.';
      //   this.isLoading = false;
      // }
    }
  },
};
</script>

<style>
.tab-text {
  padding-left: 5px !important;
  justify-content: left !important;
}
.v-tabs.theme--dark > .v-item-group {
  background-color: #424242 !important;
}
.v-tabs.theme--dark > .v-item-group > .v-window.v-item-group {
  background-color: #424242 !important;
}
.analyzed-layout-dialog
  .v-text-field.search-matched-map-list-button
  .v-input__control
  .v-input__slot {
  width: 190px;
  margin: 0px !important;
}
.analyzed-layout-dialog .search-button {
  margin: 0px !important;
}
.analyzed-layout-table a {
  font-weight: bold;
  text-decoration: underline;
  color: #0082ba !important;
}
.analyzed-layout-table table td {
  border-top: 0px !important;
  font-weight: normal !important;
  font-size: 11px !important;
}

.theme--dark .mapper-version .dialog-body {
  border-left: none;
}

.theme--dark .mapper-version .dialog-body .v-sheet {
  background-color: #292c35;
  border-left: none !important;
}
/* .content-covering-m {
  margin: 0px !important;
  padding: 20px 15px 15px 15px !important;
  background: #fafcff;
  border: 1px solid #f0f7fb;
  box-sizing: border-box;
  border-radius: 3px;
} */
/* .theme--dark .content-covering-m {
  background-color: #25272E;
  border: none;
} */
.footer-display-popup {
  padding: 0px !important;
}
.top-btn-display-m {
  padding: 0px !important;
}
.content-version-section {
  padding: 5px 0px 10px 0px;
}
.text-version,
.analyzed-layout-table table td.text-bold {
  font-weight: 600 !important;
  font-size: 11px;
  line-height: 15px;
}
.theme--dark .analyzed-layout-table table td.text-bold {
  color: #bbbbbb !important;
}
.version-history-table {
  width: 100% !important;
  max-width: 100% !important;
}
.version-history-table .v-data-table__wrapper {
  background: #fafcff;
  overflow-x: hidden;
}
.theme--dark .version-history-table .v-data-table__wrapper {
  background-color: #292c35;
}
.theme--dark .mapper-version .version-history-table table {
  border-right: none !important;
}
.theme--dark
  .version-history-table
  .v-data-table
  tbody
  tr
  td:not(.v-data-table__mobile-row) {
  border: none !important;
  border-right: 1px solid #525860 !important;
  border-bottom: 1px solid #525860 !important;
}
.mapper-version .analyzed-layout-table table td,
.mapper-version .analyzed-layout-table table thead th {
  border: none;
  border-right: 1px solid #d0d4dd;
}
.version-history-table .v-data-table thead tr:last-child th {
  border-right: 1px solid #d0d4dd;
  border-left: none;
}
.top-btn-display {
  padding: 15px 30px 0px 30px !important;
}
.align-radio {
  line-height: 0;
  display: table-cell;
  vertical-align: middle;
}
.theme--dark .version-history-table .v-data-table--fixed-header thead th {
  background: #595b64 !important;
}
.theme--dark .version-history-table .v-data-table thead tr:last-child th {
  color: #ffffff !important;
}
</style>